module.exports = __webpack_public_path__ + "static/media/crefito.0cc59f18.png";